import styled from "styled-components"

export const StyledHeroContactSection = styled.section`
  width: 100%;
  margin-bottom: 40px;
`
